import React, {useEffect} from 'react';
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import styles from './DetailsPackagePage.module.scss';
import CustomPackageOrderPage from "../CustomPackageOrderPage/CustomPackageOrderPage";
import CleanWindows from "../../../components/CleanWindows/CleanWindows";
import AdditionalServices from "../../../components/AdditionalServices/AdditionalServices";
import AddPhoto from "../../../components/AddPhoto/AddPhoto";
import SquareApartmentInput from "../../../components/SquareApartmentInput/SquareApartmentInput";
import OfferedPriceCustomer from "../../../components/OfferedPriceCustomer/OfferedPriceCustomer";
import {MAIN_ROUTES} from "../../../routing/main_routes";

const DetailsPackagePage = ({setCurrentStep}) => {
    const {service_package, finalPrice} = useSelector(state => state.stepperInfo);

    const currentStep = JSON.parse(localStorage.getItem('currentStep'));
    const navigate = useNavigate();

    useEffect(() => {
        if (currentStep !== 3) {
            navigate(MAIN_ROUTES.CREATE_ORDER);
        }
    }, [currentStep]);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }, []);

    return (
        <div className={styles.detailsPackagePage_wrapper}>
            {
                (service_package?.name !== 'Індивідуальний пакет') ?
                    <div className={styles.detailsPackagePage_wrapper_detailsPackage}>
                        <SquareApartmentInput/>
                        <CleanWindows/>
                        <AdditionalServices/>
                        <AddPhoto setCurrentStep={setCurrentStep}/>
                        <OfferedPriceCustomer minPrice={finalPrice}/>
                    </div> :
                    <CustomPackageOrderPage setCurrentStep={setCurrentStep}/>
            }
        </div>
    );
};

export default DetailsPackagePage;
